import React from 'react';
import TabOfDataTable from '../../../../Elements/DataTable/TabOfDataTable';
import ShownPanelsEnum from '../../../../Enums/ShownPanelsEnum';
import TpClientInvoiceJobLineSearchParams from './TpClientInvoiceJobLineSearchParams';
import TpClientInvoiceJobLineService from '../../../../Services/TpClientInvoiceJobLineService';
import TpClientInvoiceJobLine from '../../../../Domain/TpClientInvoiceJobLine';
import ErrorMessage from '../../../../Elements/ErrorMessage';
import OrderDirectionsEnum from '../../../../Enums/OrderDirectionsEnum';
import TpClientInvoiceStatusEnum from '../../../../Enums/ClientInvoiceStatusEnum';
import CrudTypesEnum from '../../../../Enums/CrudTypesEnum';
import ButtonColorsEnum from '../../../../Enums/ButtonColorsEnum';
import GeneralEditWizzardBase from '../../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import FigmaButtonRow from '../../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../../Enums/IconPositionEnum';
import RemoveTpClientInvoiceLineItems from '../../../../Domain/RemoveTpClientInvoiceLineItems';
import TpClientInvoiceService from '../../../../Services/TpClientInvoiceService';
import TpClientInvoiceJobLineMultiEditItem from '../../../../Domain/TpClientInvoiceJobLineMultiEditItem';
import EditMultipleTpClientInvoiceJobLinesWindowDescription from './EditMultipleTpClientInvoiceJobLinesWindowDescription';
import GenerateEvaluatorIobWindowDescription from './GenerateEvaluatorIobWindowDescription';
import ManualEvaluatorIobItem from '../../../../Domain/ManualEvaluatorIobItem';
import { getRemoveQuestion } from '../../../../Helpers/invoiceAutomationStatusHelper';

export default class TpClientInvoiceJobLineSubTab extends React.Component {
  static defaultProps = {
    tpClientInvoiceId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchItem: new TpClientInvoiceJobLineSearchParams(),
      shownPanel: ShownPanelsEnum.None,
      itemList: [],
      allItemsInTheSearchSetAreSelected: false,
      numberOfElementsInTheTable: 0,
      status: null,
      clientId: null,
      invoiceAutomationIsActive: null,
    };
    this.state.searchItem.TpClientInvoiceId = props.tpClientInvoiceId;
    TpClientInvoiceJobLineSearchParams.getClientId = () => this.state.clientId;

    EditMultipleTpClientInvoiceJobLinesWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    EditMultipleTpClientInvoiceJobLinesWindowDescription.getSelected = this.getSelected.bind(this);
    EditMultipleTpClientInvoiceJobLinesWindowDescription.getAllItemsInTheSearchSetAreSelected =
      this.getAllItemsInTheSearchSetAreSelected.bind(this);

    GenerateEvaluatorIobWindowDescription.getSelected = this.getSelected.bind(this);
    GenerateEvaluatorIobWindowDescription.getTpClientInvoiceId = () => this.props.tpClientInvoiceId;

    this.serviceFunction = this.serviceFunction.bind(this);
    this.refresh = this.refresh.bind(this);
    this.removeFunction = this.removeFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
  }

  componentDidMount() {
    TpClientInvoiceService.GetSimpleById(this.props.tpClientInvoiceId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          this.setState({
            status: result.status,
            clientId: result.caspianClientId,
            invoiceAutomationIsActive: result.invoiceAutomationIsActive,
          });
        }
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCIJLST60', error));
  }

  getAllItemsInTheSearchSetAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSearchParameters() {
    return this.state.searchItem;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  refresh(reload) {
    if (reload) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
      return;
    }
    this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  isButtonDisabled() {
    return this.state.status !== TpClientInvoiceStatusEnum.Draft;
  }

  getNumberOfSelectedElements() {
    return this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
  }

  handleExportExcelButtonClick() {
    TpClientInvoiceJobLineService.ExportToExcel(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPCIJLST97')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  removeFunction() {
    const item = new RemoveTpClientInvoiceLineItems();
    item.TpClientInvoiceId = this.props.tpClientInvoiceId;
    item.RemoveItemIds = this.state.itemList.filter((i) => i.Selected).map((i) => 'Job_' + i.TpJobId.toString());
    item.JobLineSearchItem = this.getSearchParameters();

    if (this.state.numberOfElementsInTheTable > 500 && this.getAllItemsInTheSearchSetAreSelected()) {
      TpClientInvoiceService.RemoveLines(item, this.getAllItemsInTheSearchSetAreSelected()).catch((error) => {
        ErrorMessage.SetErrorMessage('TPCIJLST111', error);
      });

      ErrorMessage.SetNotification(
        'Started removing the line items in the background. You will receive an in-app notification when the process is done.'
      );
      return;
    }

    TpClientInvoiceService.RemoveLines(item, this.getAllItemsInTheSearchSetAreSelected())
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          ErrorMessage.SetLoading(false);
          this.refresh(false);
          return;
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Line Item(s) Removed.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCIJLST136', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getEditItem() {
    // When the whole search set is selected the browser only holds the current page, so the
    // currencies resolved here are a best effort for labelling. The backend re-resolves the
    // pricing and evaluator currencies across every affected job and refuses the update if they are
    // not all the same. Client amounts need no such gate: they are typed in the invoice currency and
    // converted per line on save where the line currency differs.
    const rows = this.getAllItemsInTheSearchSetAreSelected()
      ? this.state.itemList
      : this.state.itemList.filter((i) => i.Selected);
    const distinct = (value, index, array) => array.indexOf(value) === index;

    const invoiceCurrencies = rows
      .map((f) => f.CurrencyCode)
      .filter((code) => code)
      .filter(distinct);
    const fieldworkCurrencies = rows
      .map((f) => f.TpJobPricingCurrencyCode)
      .filter((code) => code)
      .filter(distinct);
    const evaluatorCurrencies = rows
      .map((f) => f.EvaluatorPaymentCurrencyCode)
      .filter((code) => code)
      .filter(distinct);

    return new TpClientInvoiceJobLineMultiEditItem(
      invoiceCurrencies.length === 1 ? invoiceCurrencies[0] : '',
      fieldworkCurrencies,
      evaluatorCurrencies
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.MultiEdit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.getEditItem()}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditMultipleTpClientInvoiceJobLinesWindowDescription}
            errorCode={'TPCIJLST153'}
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.GenerateEvaluatorIob,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ManualEvaluatorIobItem()}
            clickOnCancel={() => this.refresh(false)}
            clickOnSave={() => this.refresh(true)}
            windowDescription={GenerateEvaluatorIobWindowDescription}
            errorCode={'TPCIJLST160'}
          />
        )}
      </div>
    );
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => {
                TpClientInvoiceJobLineService.ExportToExcel(this.state.searchItem)
                  .then((result) => {
                    if (result && result.error) {
                      ErrorMessage.SetErrorMessage(result.error);
                    } else {
                      ErrorMessage.SetNotification('Exported to Excel.');
                    }
                  })
                  .catch(() => ErrorMessage.SetErrorMessage('TPCIJLST178'));
              },
              label: 'Export to Excel',
              tooltip: 'Export to Excel',
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () =>
                ErrorMessage.SetApprove(
                  getRemoveQuestion(
                    `Remove ${this.getNumberOfSelectedElements()} Assignment(s) from their invoice?`,
                    this.state.invoiceAutomationIsActive
                  ),
                  this.removeFunction
                ),
              label: 'Remove Line Items',
              tooltip: 'Remove Line Items',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.MultiEdit }),
              label: 'Update Multiple Records',
              tooltip: 'Update Multiple Records',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.getNumberOfSelectedElements() === 0 || this.isButtonDisabled(),
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.GenerateEvaluatorIob }),
              label: 'Generate Evaluator IOB',
              tooltip: 'Generate Evaluator Fee / Expense IOB for selected Puerto Rico shops',
              roleKey: 'tpclientinvoices_manualevaluatoriob',
              disabled: this.getNumberOfSelectedElements() === 0,
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  serviceFunction(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache) {
    const tempSearchItem = { ...searchItem };
    tempSearchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
    return TpClientInvoiceJobLineService.GetListBySearching(
      orderById,
      orderDir,
      pageNumber,
      numberOfElements,
      tempSearchItem,
      clearCache
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpClientInvoiceJobLine}
          serviceFunction={this.serviceFunction}
          convertDBItemsFunction={TpClientInvoiceJobLineService.ConvertDBItems}
          orderDirection={OrderDirectionsEnum.Asc}
          orderBy='ProjectName'
          itemList={this.state.itemList}
          shownPanel={this.state.shownPanel}
          searchParamsType={TpClientInvoiceJobLineSearchParams}
          showSearchStrip={true}
          clickOnStartSearch={(searchItem) => {
            // "Clear All Filters" hands back a fresh search item without the invoice id. The list re-adds
            // it for its own fetch, but the bulk actions send this item as it is, and the server scopes a
            // select-all by it.
            searchItem.TpClientInvoiceId = this.props.tpClientInvoiceId;
            this.setState({ searchItem });
          }}
          searchItem={this.state.searchItem}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in assignment third-party ID...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='tpclientinvoices_view'
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          errorCode='TPCIJLST236'
        />
      </div>
    );
  }
}
